import './primo-piano.scss';

/**
 * version    1.0
 * class      <type> (PrimoPiano)
 * classdesc
 */
export class PrimoPiano {}
